<template>
    <WindowedForm v-model="form" />
</template>
<script>

    import InteractionsService from "../../services/InteractionService.js";
    import WindowedForm from "../globalUiElements/WindowedForm.vue";
    import { createParameterFields } from "../../utils/ParameterUtils.js";
    import { createForm } from "../../utils/FormUtils.js";
    import { updateLookups } from '../../utils/referenceUtils.js';
    import { l } from "../../utils/LocalizationUtils.js";


    export default {
        components: {
            WindowedForm
        },
        props: {
            entry: { type: Object, default: null }
        },
        data() {
            return {
                form: {}
            };
        },
        async mounted() {

            await updateLookups(["tags"]);

            this.form = createForm({

                title: {
                    label: "Edit Settings of Interaction ${v}",
                    entry: this.entry.name
                },

                action: InteractionsService.updateInteraction,

                fieldDefs: [
                    {
                        uiElement: "Info",
                        label: "Interaction Module:",
                        value: this.entry.interactionModuleId + " (v" + this.entry.interactionModuleVersion + ")"
                    },
                    {
                        key: "_id",
                        type: "Hidden",
                        value: this.entry._id
                    },
                    {
                        key: "arTargetId",
                        type: "Hidden",
                        value: this.entry.arTargetId
                    },
                    {
                        key: "interactionModuleId",
                        type: "Hidden",
                        value: this.entry.interactionModuleId
                    },
                    {
                        key: "interactionModuleVersion",
                        type: "Hidden",
                        value: this.entry.interactionModuleVersion || 0
                    },
                    {
                        key: "name",
                        type: "Text",
                        label: "Name in CMS (not shown in the app)",
                        value: this.entry.name,
                        required: true
                    },
                    {
                        uiElement: "Spacer"
                    },
                    {
                        uiElement: "Title",
                        icon: "mdi-record-circle-outline",
                        text: "Point of interest (as seen in App)"
                    },
                    {
                        key: "positionX",
                        type: "Number",
                        label: "Position x axis",
                        value: this.entry.positionX,
                        required: true
                    },
                    {
                        key: "positionY",
                        type: "Number",
                        label: "Position y axis",
                        value: this.entry.positionY,
                        required: true
                    },
                    {
                        key: "isIntroduction",
                        type: "Hidden",
                        value: this.entry.isIntroduction || false
                    },
                    {
                        key: "hidePoiIfIntroduction",
                        type: "Hidden",
                        value: this.entry.hidePoiIfIntroduction || false
                    },
                    {
                        key: "poiLabel",
                        type: "Text",
                        label: "Label",
                        localized: true,
                        value: this.entry.poiLabel || {}
                    },
                    {
                        key: "hidePoiLabel",
                        type: "Checkbox",
                        label: "Hide Label",
                        value: this.entry.hidePoiLabel || false
                    },
                    {
                        key: "poiIcon",
                        type: "Select",
                        label: "Icon of point of interest",
                        options: [
                            { value: "Dot", text: "Default" },
                            { value: "Detail", text: "Detail" },
                            { value: "Fun", text: "Special" },
                            { value: "Identity", text: "Identity" },
                            { value: "Links", text: "Link" },
                            { value: "Reveal", text: "Reveal" }
                        ],
                        value: this.entry.poiIcon || "Dot",
                        showPoiIconHelp: true
                    },
                    {
                        key: "hideInBasicAR",
                        type: "Checkbox",
                        label: "Hide point of interest in regular Art Scanner mode",
                        value: this.entry.hideInBasicAR || false
                    },
                    {
                        uiElement: "Spacer"
                    },
                    {
                        uiElement: "Title",
                        icon: "mdi-gesture-tap-button",
                        text: "Behavior"
                    },
                    {
                        uiElement: "Info",
                        label: "Is the art piece's introduction:",
                        value: this.entry.isIntroduction ? "Yes" : "No"
                    },
                    {
                        key: "openOnTrackingStart",
                        type: "Checkbox",
                        label: "Open interaction when tracking of art piece starts",
                        value: this.entry.openOnTrackingStart
                    },
                    {
                        key: "closeOnTrackingEnd",
                        type: "Checkbox",
                        label: "Close interaction when tracking of art piece stops",
                        value: this.entry.closeOnTrackingEnd
                    },
                    {
                        key: "cannotBeClosed",
                        type: "Checkbox",
                        label: "User cannot close interaction manually",
                        value: this.entry.cannotBeClosed
                    },
                    {
                        key: "showInfoBoxDuringInteraction",
                        type: "Checkbox",
                        label: "Art piece information box is visible during interaction",
                        value: this.entry.showInfoBoxDuringInteraction
                    },
                    {
                        key: "isBackgroundOfPOISelection",
                        type: "Checkbox",
                        label: "Serves as background of art piece's POI selection",
                        value: this.entry.isBackgroundOfPOISelection || false
                    },
                    {
                        key: "transform",
                        type: "Text",
                        label: "Transform (9 comma-separated values: 3 translate, 3 rotation, 3 scale)",
                        value: this.entry.transform
                    },
                    {
                        key: "tags",
                        type: "Tags",
                        label: "Tags",
                        value: this.entry.tags || []
                    },
                    ...createParameterFields(this.entry.interactionModule.parameters, this.entry.parameters, true)
                ],

                submitLabel: "Save",

                submitted: entry => {
                    this.$root.$emit("success", l("Changes to interaction \"${v.name}\" saved.", entry));
                    this.$emit("editedEntry");
                },

                cancelled: () => {
                    this.$emit("cancel");
                }
            });
        }
    }
</script>